import React, { useState, useEffect, useContext } from "react";
import { api } from "../../api";
import Ctx from "../../contexts/AppContext";
import { crd, bdg, sp, rad, type, icBox, listRow } from "../../constants/styles";
import Ic from "../common/Ic";

export default function AdminOrgs() {
  const { h, go, setSelOrgId } = useContext(Ctx);
  const [orgs, setOrgs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [planFilter, setPlanFilter] = useState("all");
  const [statusFilter, setStatusFilter] = useState("all");

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      const params = {};
      if (search) params.search = search;
      if (planFilter !== "all") params.plan = planFilter;
      if (statusFilter !== "all") params.status = statusFilter;
      const res = await api.adminGetOrgs(params);
      if (res.success) setOrgs(res.orgs || []);
      setLoading(false);
    };
    const timer = setTimeout(load, search ? 400 : 0);
    return () => clearTimeout(timer);
  }, [search, planFilter, statusFilter]);

  const planColors = { free: h.wn, starter: h.ac, growth: h.pp || "#8b5cf6", business: h.gn, pro: h.gn };

  const tabS = (active) => ({
    padding: `${sp.xs}px ${sp.md}px`, borderRadius: rad.pill, border: "none",
    background: active ? h.ac : "transparent", color: active ? "#fff" : h.ts,
    fontSize: 11, fontWeight: active ? 600 : 400, cursor: "pointer",
  });

  return <div style={{ paddingTop: sp.lg }} className="animate-fadeIn">
    <button onClick={() => go("dash")} style={{ background: "none", border: "none", color: h.ac, cursor: "pointer", ...type.sm, marginBottom: sp.md, display: "flex", alignItems: "center", gap: sp.xs }}>
      <Ic n="arrow-left" s={14} c={h.ac} /> Dashboard
    </button>

    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: sp.lg }}>
      <h2 style={{ ...type.h2, color: h.tx, margin: 0 }}>All Organizations</h2>
      <span style={{ ...type.xs, color: h.ts }}>{orgs.length} found</span>
    </div>

    {/* Search */}
    <div style={{ position: "relative", marginBottom: sp.md }}>
      <div style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)" }}>
        <Ic n="search" s={16} c={h.tt} />
      </div>
      <input value={search} onChange={e => setSearch(e.target.value)}
        placeholder="Search name, phone, or slug..."
        style={{ width: "100%", padding: `${sp.sm}px ${sp.md}px`, paddingLeft: 36, borderRadius: rad.md, border: `1px solid ${h.bd}`, background: h.ib, color: h.tx, ...type.sm, outline: "none", boxSizing: "border-box" }}
      />
    </div>

    {/* Filters Row */}
    <div style={{ display: "flex", gap: sp.sm, marginBottom: sp.lg, overflowX: "auto" }}>
      <div style={{ display: "flex", gap: sp.xs }}>
        {["all", "active", "inactive"].map(f => <button key={f} onClick={() => setStatusFilter(f)} style={tabS(statusFilter === f)}>
          {f === "all" ? "All" : f.charAt(0).toUpperCase() + f.slice(1)}
        </button>)}
      </div>
      <div style={{ width: 1, background: h.bd, margin: `0 ${sp.xs}px` }} />
      <div style={{ display: "flex", gap: sp.xs }}>
        {["all", "free", "starter", "growth", "business"].map(f => <button key={f} onClick={() => setPlanFilter(f)} style={tabS(planFilter === f)}>
          {f === "all" ? "All Plans" : f.charAt(0).toUpperCase() + f.slice(1)}
        </button>)}
      </div>
    </div>

    {/* Loading */}
    {loading && <div style={{ textAlign: "center", padding: sp.xxxl }}>
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke={h.ac} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ animation: "spin 1s linear infinite" }}><path d="M21 12a9 9 0 11-6.219-8.56" /></svg>
    </div>}

    {/* Empty */}
    {!loading && orgs.length === 0 && <div style={{ ...crd(h), textAlign: "center", padding: sp.xxxl }}>
      <Ic n="building" s={24} c={h.tt} />
      <div style={{ ...type.sm, color: h.tt, marginTop: sp.sm }}>No organizations found</div>
    </div>}

    {/* Org List */}
    {!loading && orgs.length > 0 && <div style={{ ...crd(h), padding: 0, overflow: "hidden" }}>
      {orgs.map((org, i) => {
        const pCol = planColors[org.plan] || h.ac;
        return <div key={org.id}
          onClick={() => { setSelOrgId(org.id); go("adminOrgDetail"); }}
          style={{ ...listRow(h, i === orgs.length - 1), cursor: "pointer" }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: sp.md, flex: 1 }}>
            <div style={icBox(h.ac, 36)}>
              <Ic n="building" s={16} c={h.ac} />
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ display: "flex", alignItems: "center", gap: sp.xs, flexWrap: "wrap" }}>
                <span style={{ ...type.sm, color: h.tx, fontWeight: 600 }}>{org.name}</span>
                <span style={{ ...bdg(`${pCol}20`, pCol), fontSize: 9 }}>{(org.plan || "free").toUpperCase()}</span>
                {!org.active && <span style={{ ...bdg(`${h.rd}20`, h.rd), fontSize: 9 }}>Inactive</span>}
              </div>
              <div style={{ ...type.xs, color: h.tt, marginTop: 2 }}>
                {org.owner_phone || "No phone"} · {org.prop_count || 0} props · {org.tenant_count || 0} tenants
              </div>
            </div>
          </div>
          <Ic n="chevron-right" s={16} c={h.tt} />
        </div>;
      })}
    </div>}
  </div>;
}
